import React, { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AutoSelectProvider } from 'shared-modules/providers';
import { getSelectionTagsRequest, getApGroupRequest } from '../../redux/actions';
import { SplitPane } from '../../components';
import { SideMenu } from './components/SideMenu';
import { Detail } from './components/Detail';
import styles from './autoSelect.module.scss';

const AutoSelect = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getApGroupRequest({ serviceId: 'fx' }));
    dispatch(getApGroupRequest({ serviceId: 'etf' }));
    dispatch(getApGroupRequest({ serviceId: 'cfd' }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getSelectionTagsRequest());
  }, [dispatch]);

  return (
    <AutoSelectProvider>
      <div className={styles.container}>
        <div className={styles.content}>
          <SplitPane defaultSize={386} minSize={386} maxSize={500}>
            <div className={styles.sideMenu}>
              <SideMenu />
            </div>
            <Detail />
          </SplitPane>
        </div>
      </div>
    </AutoSelectProvider>
  );
};

export default memo(AutoSelect);
